import React from "react";
import "../SCSS/Styles.css";
import MetaTags from "react-meta-tags";
import Section_1 from "./Section_1";
import Section_2 from "./Section_2";
import Section_3 from "./Section_3";
import Section_4 from "./Section_4";
import Section_5 from "./Section_5";
import Section_6 from "./Section_6";
import Section_7 from "./Section_7";
import Section_8 from "./Section_8";
import Section_9 from "./Section_9";
import Section_10 from "./Section_10";
import Section_11 from "./Section_11";
import BrsrOtherProducts from "../../BrsrLandingPage/components/BrsrOtherProducts";
import LogoCarousel from "../../Landing/components/LogoCarousel";
import Platform from "../../Landing/components/Resources";
import Clients from "../../Landing/components/Clients";
import Demo from "../../Demo";

function CsrdHome({
  activeIndex,
  toggleAccordion,
  otherProductsList,
  blogsData,
  handleNextButton,
  clientDetails,
  index,
  handleBackButton,
  characterCount,
  handleReadMore,
  readMoreBool,
}) {
  return (
    <div className="csrd-landing-page-container">
      <MetaTags>
        <title>ESG Software - AI Powered CSRD Reporting Software</title>
        <meta
          name="description"
          content="Updapt simplifies this process—bringing automation, AI, and XBRL compliance into one seamless platform."
        />
        <meta property="og:title" content="ESG Software - AI Powered CSRD Reporting Software" />
        <meta property="og:image" content="%PUBLIC_URL%/static/media/banner.jpg" />
        {/* <script type="application/ld+json" async>
          {JSON.stringify(structuredData)}
        </script> */}
      </MetaTags>
      <Section_1 />
      <Section_2 />
      <Section_3 />
      <Section_4 />
      <Section_5 />
      <Section_6 />
      <Section_7 />
      <Section_8 />
      <Section_9 />
      <Section_10 />
      <Section_11 activeIndex={activeIndex} toggleAccordion={toggleAccordion} />
      <BrsrOtherProducts otherProductsList={otherProductsList} />
      <LogoCarousel />
      <Platform blogsData={blogsData} />
      <Clients
        handleNextButton={handleNextButton}
        clientDetails={clientDetails}
        index={index}
        handleBackButton={handleBackButton}
        characterCount={characterCount}
        handleReadMore={handleReadMore}
        readMoreBool={readMoreBool}
      />
      <Demo />
    </div>
  );
}

export default CsrdHome;
